import React, { useState, useEffect } from 'react';
import { Button } from '../components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../components/ui/dropdown-menu';
import { Globe } from 'lucide-react';

const ADMIN_LANGUAGES = [
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' }
];

export const useAdminLanguage = () => {
  const [language, setLanguageState] = useState(() => {
    return localStorage.getItem('afy_admin_language') || 'fr';
  });

  const setLanguage = (lang) => {
    if (ADMIN_LANGUAGES.some(l => l.code === lang)) {
      setLanguageState(lang);
      localStorage.setItem('afy_admin_language', lang);
    }
  };

  return { language, setLanguage, languages: ADMIN_LANGUAGES };
};

export default function AdminLanguageSelector() {
  const { language, setLanguage, languages } = useAdminLanguage();
  const currentLang = languages.find(l => l.code === language) || languages[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="gap-2" data-testid="admin-language-selector">
          <Globe className="w-4 h-4" />
          <span>{currentLang.flag}</span>
          <span className="hidden sm:inline">{currentLang.name}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {languages.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            onClick={() => setLanguage(lang.code)}
            className={`gap-2 cursor-pointer ${language === lang.code ? 'bg-accent/10' : ''}`}
          >
            <span>{lang.flag}</span>
            <span>{lang.name}</span>
            {language === lang.code && <span className="ml-auto">✓</span>}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
